import Component, { ComponentLoader } from '@bythepixel/component-loader';
import { list, total, onChange } from 'cart-localstorage';
import RemoveFromCart from './removeFromCart';
import ChangeQuantity from './changeQuantity';

export default class AddToCart extends Component {
  static selector = '[data-comp-cart-view]';

  constructor(containerEl) {
    super(containerEl);
    this.cart = this.$container.querySelector('[data-cart-view-cart]');
    this.cartTotals = this.$container.querySelectorAll('[data-cart-view-total]');
    this.checkoutLink = this.$container.querySelector('[data-checkout-link]');
    this.siteURLBase = `${window.CIMARRON.env.shopifyShopUrl}/cart`;
    this.cartItemsString = null;
    this.vinNumber = this.$container.querySelector('[data-cart-vin-number]');
    this.vinNumber.addEventListener('input', () => this.setCheckoutLinkHref());
    this.renderCart();
    onChange(() => this.renderCart(list()));
  }

  renderCart() {
    if (window?.CIMARRON?.cartIcon) {
      window.CIMARRON.cartIcon.renderCartIcon();
    }
    const items = list();
    if (items.length > 0) {
      this.cart.innerHTML = items.map((item) => `
        <div class="flex items-center py-4">
          <div class="min-w-0 flex-1 flex items-center">
            <div class="flex-shrink-0">
              <img
                class="h-12 w-12"
                src="${item.imageSrc}"
                alt="${item.imageAlt}"
              >
            </div>
            <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-3 md:gap-4">
              <div class="col-span-2">
                <h3 class="text-base">${item.name}</h3>
                ${item.variantTitle !== 'Default Title' ? `<h3 class="text-base mt-1">(${item.variantTitle})</h3>` : ''}
                <div>$${(item.price * item.quantity).toFixed(2)}</div>
              </div>
              <div
                class=""
                data-comp-change-quantity
                data-comp-change-cart-quantity
                data-product-id="${item.id}"
              >
                <label for="${item.id}__quantity">Qty:</label>
                <input
                    class="shadow-sm focus:ring-primary focus:border-primary sm:text-sm border-gray-300 rounded-md"
                    type="number"
                    size="4"
                    min="1"
                    value="${item.quantity}"
                    max="${item.availableQuantity}"
                    name="${item.id}__quantity"
                    id="${item.id}__quantity"
                    data-quantity
                >
              </div>
            </div>
            <button
              class="h-12 w-12 text-gray-400 text-3xl md:text-md3xl leading-none transform -translate-y-1"
              data-product-id="${item.id}"
              data-comp-remove-from-cart
            >&times;</button>
          </div>
        </div>`).join('');
    } else {
      this.cart.innerHTML = '<h2>No items in cart</h2>';
    }

    this.cartTotals.forEach(cartTotal => {
      const thisCartTotal = cartTotal;
      thisCartTotal.innerHTML = `$${total().toFixed(2)}`;
    });

    this.cartItemsString = items.map((item) => `${item.id}:${item.quantity}`).join(',');
    this.setCheckoutLinkHref();

    this.subcomponents = new ComponentLoader(this.$container, [RemoveFromCart, ChangeQuantity]);
  }

  setCheckoutLinkHref() {
    if (this.vinNumber.value) {
      const searchParams = new URLSearchParams({ note: `VIN: ${this.vinNumber.value}` });
      this.checkoutLink.href = `${this.siteURLBase}/${this.cartItemsString}?${searchParams.toString()}`;
    } else {
      this.checkoutLink.href = `${this.siteURLBase}/${this.cartItemsString}`;
    }
  }
}
